import { HandHeartIcon, HeartIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react'
import type { Feature, Localized } from '../types/content'

export const values: Feature[] = [
  {
    id: 'dignity',
    icon: HeartIcon,
    title: { en: 'Dignity', es: 'Dignidad' },
    body: {
      en: 'We honor each person’s history, choices, and privacy, and encourage independence wherever possible.',
      es: 'Honramos la historia, las decisiones y la privacidad de cada persona, y fomentamos su independencia siempre que sea posible.',
    },
  },
  {
    id: 'trust',
    icon: ShieldCheckIcon,
    title: { en: 'Trust', es: 'Confianza' },
    body: {
      en: 'Punctual, honest, and dependable caregivers, backed by an agency that answers the phone day or night.',
      es: 'Cuidadores puntuales, honestos y confiables, respaldados por una agencia que contesta el teléfono de día o de noche.',
    },
  },
  {
    id: 'family',
    icon: UsersIcon,
    title: { en: 'Family partnership', es: 'Alianza con la familia' },
    body: {
      en: 'You know your loved one best. We keep you informed and even teach family members how to help between visits.',
      es: 'Tú conoces mejor a tu ser querido. Te mantenemos informado e incluso enseñamos a la familia a ayudar entre visitas.',
    },
  },
  {
    id: 'love',
    icon: HandHeartIcon,
    title: { en: 'Loving care', es: 'Cuidado con amor' },
    body: {
      en: 'Unique and loving care is in our name and our tagline. It is the standard every caregiver is held to.',
      es: 'El cuidado único y amoroso es nuestro lema. Es el estándar que cada cuidador debe cumplir.',
    },
  },
]

export const credentials: Localized[] = [
  { en: 'Licensed home care agency in Virginia', es: 'Agencia de cuidado en el hogar licenciada en Virginia' },
  { en: 'Fully bonded and insured', es: 'Completamente afianzada y asegurada' },
  { en: 'Criminal background checks on every caregiver', es: 'Verificación de antecedentes a cada cuidador' },
  { en: 'CPR and First Aid certified caregivers', es: 'Cuidadores certificados en RCP y Primeros Auxilios' },
  { en: "Specialized Alzheimer's and dementia training", es: 'Capacitación especializada en Alzheimer y demencia' },
  { en: 'Ongoing supervision and care-plan reviews', es: 'Supervisión continua y revisión de planes de cuidado' },
]
